import { useFrame } from '@react-three/fiber'
import * as THREE from 'three'
import { useMemo, useRef } from 'react'
import { easing } from 'maath'

const dummy = new THREE.Object3D()

export default function SnowFlakes({ count = 300 }) {
  const mesh = useRef()

  const particles = useMemo(() => {
    const temp = []
    for (let i = 0; i < count; i++) {
      // Random X/Z in a wide area (adjust radius to fit your globe)
      const radius = 1 + Math.random() * 3 // 5 to 13 units wide
      const angle = Math.random() * Math.PI * 2
      const x = Math.cos(angle) * radius
      const z = Math.sin(angle) * radius

      // Start high up
      const y = Math.random() * 8 

      // Individual falling speed (slower = more gentle)
      const fallSpeed = 0.2 + Math.random() * 0.6  // units per second

      // Gentle horizontal sway amplitude and frequency
      const swayAmp = 0.5 + Math.random() * 1
      const swayFreq = 0.5 + Math.random() * 1

      // Random scale
      const scale = 0.3 + Math.random() * 0.7

      // Rotation speed for tumbling effect
      const rotSpeed = Math.random() * 2

      temp.push({
        x, y, z,
        fallSpeed,
        swayAmp,
        swayFreq,
        scale,
        rotSpeed,
        offset: Math.random() * Math.PI * 2  // for varied sway timing
      })
    }
    return temp
  }, [count])

  useFrame((state, delta) => {
    // Optional: whole system gently rotates with mouse (keep if you like it)
    easing.damp3(mesh.current.rotation, [0, -state.mouse.y * Math.PI * 0.1, 0], 0.75, delta)

    particles.forEach((p, i) => {
      // Fall down
      p.y -= p.fallSpeed * delta * 0.8  

      // Reset to top when too low
      if (p.y < 1) {
        p.y = 1 + Math.random() * 4  // respawn higher
      }

      // Gentle side sway (sin wave)
      const swayX = Math.sin(state.clock.elapsedTime * p.swayFreq + p.offset) * p.swayAmp
      const swayZ = Math.cos(state.clock.elapsedTime * p.swayFreq * 0.7 + p.offset) * p.swayAmp * 0.5

      // Position with sway
      dummy.position.set(p.x + swayX, p.y, p.z + swayZ)

      // Scale
      dummy.scale.setScalar(p.scale)

      // Tumbling rotation
      dummy.rotation.set(
        state.clock.elapsedTime * p.rotSpeed,
        state.clock.elapsedTime * p.rotSpeed * 1.3,
        0
      )

      dummy.updateMatrix()
      mesh.current.setMatrixAt(i, dummy.matrix)
    })

    mesh.current.instanceMatrix.needsUpdate = true
  })

  return (
    <instancedMesh ref={mesh} args={[null, null, count]}>
      <dodecahedronGeometry args={[0.1, 0]} />
      <meshStandardMaterial color="#e0e0ff" emissive="#aaaaaa" emissiveIntensity={1.5} />
    </instancedMesh>
  )
}